module.exports = __webpack_public_path__ + "img/home-f.278ef811.svg";